<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <h4 class="mb-0 font-size-18">
            {{ $t(title) }} : {{ group.name }}
          </h4>
  
          <div class="page-title-right">
            <div class="col text-right">
              <b-button 
                @click="showModal = true"
                v-b-modal.modal-lg 
                variant="primary">
                <b>Nouveau</b>
              </b-button>
            </div>
          </div>
          <b-modal
            id="modal-lg"
            v-model="showModal"
            size="lg"
            :title="$t('pages.groups.users.actions.create')"
            title-class="font-18"
            hide-footer
          >
            <form @submit.prevent="addUserToGroup">
              <div class="row mt-4">
                <div class="col">
                  <multiselect
                    v-model="forms.user"
                    :options="forms.users"
                    :multiple="true"
                    :tage-placeholder="
                      $t('pages.groups.users.search')
                    "
                    :placeholder="$t('pages.groups.users.user')"
                    :custom-label="completeName"
                    track-by="id"
                    :taggable="true"
                  ></multiselect>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col">
                  <button
                    type="button"
                    class="btn btn-outline-light btn-block"
                    @click="closeModal"
                    data-dismiss="modal"
                  >
                    {{ $t("pages.documentType.cancel") }}
                  </button>
                </div>
                <div class="col">
                  <button
                    type="submit"
                    v-if="this.isLoading === false"
                    class="btn btn-primary btn-block"
                  >
                    {{ $t("pages.documentType.save") }}
                  </button>
                  <button
                    class="btn btn-primary btn-block"
                    type="button"
                    v-else
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {{ $t("pages.documentType.saving") }}
                  </button>
                </div>
              </div>
            </form>
          </b-modal>
        </div>
            <div class="row mb-3" v-if="selectedUsers.length !== 0">
              <div class="col-12">
                <b-button 
                  @click="onDeleteUsers()"
                  variant="primary">
                  <i class="bx bx-trash"></i> {{ $t("pages.groups.users.delete") }}
                </b-button>
              </div>
            </div>
            <div v-if="isLoading" class="mt-2">
              <b-skeleton-table :rows="6" :columns="4"></b-skeleton-table>
            </div>
            <div class="row" v-else-if="pageOfItems.length > 0">
              <div class="col-12 col-md-6 d-block d-lg-none"  v-for="user in pageOfItems" :key="user.id">
                <b-card class="border">
                  <b-dropdown
                    class="card-drop float-right"
                    variant="white"
                    right
                    toggle-class="p-0"
                  >
                    <template v-slot:button-content>
                        <i class="mdi mdi-dots-vertical font-size-18"></i>
                    </template>
                    <b-dropdown-item @click="onDelete(user)">
                        {{ $t("pages.groups.users.delete") }}
                    </b-dropdown-item>
                  </b-dropdown>
                  
                  <b-card-title>
                    {{ user.firstname }} {{ user.lastname }}
                  </b-card-title>

                  <b-card-text>{{ user.phone }}</b-card-text>

                  <b-card-text class="small text-muted">{{ user.email }}</b-card-text>
                </b-card>
              </div>
              <div class="col-12 d-none d-lg-table">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th><input type="checkbox" v-model="selectAllUsers"></th>
                      <th>{{ $t("pages.users.firstname") }}</th>
                      <th>{{ $t("pages.users.lastname") }}</th>
                      <th>{{ $t("pages.users.phone") }}</th>
                      <th>{{ $t("pages.users.mail") }}</th>
                      <td></td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in pageOfItems" :key="user.id">
                      <td><input type="checkbox"  :value="user.user_id" v-model="selectedUsers"></td>
                      <td>{{ user.firstname }}</td>
                      <td>{{ user.lastname }}</td>
                      <td>{{ user.phone }}</td>
                      <td>{{ user.email }}</td>
                      <td class="text-center">
                          <b-dropdown
                              class="card-drop"
                              variant="white"
                              right
                              toggle-class="p-0"
                          >
                              <template v-slot:button-content>
                                  <i class="mdi mdi-dots-horizontal font-size-18"></i>
                              </template>
                              <b-dropdown-item @click="onDelete(user)">
                                  {{ $t("pages.groups.users.delete") }}
                              </b-dropdown-item>
                          </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-center" v-if="group.users.length == 0 && !isLoading">
              <h4 class="text-center">{{ $t("pages.groups.users.empty.title") }}</h4>
              <p class="mt-2">
                {{ $t("pages.groups.users.empty.text") }}
              </p>
            </div>
          <div class="row mb-4">
            <div class="col-md-12">
              <div class="text-center">
                <jw-pagination
                  :pageSize="pageSize"
                  :items="group.users"
                  @changePage="onChangePage"
                  :labels="labels"
                  class="text-center"
                ></jw-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";

export default {
  page: {
    title: "users",
  },
  components: {
    Layout,
    Multiselect,
  },

  data() {
    return {
      title: "pages.groups.users.name",      
      showModal: false,      
      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },
      group: {
        name: "",
        description: "",
        users: []
      },
      selectedUsers: [],
      forms: {
        users: [],
        name: "",
        description: "",
        user: [],
      },
      isLoading: false,
      pageOfItems: [],
      pageSize: 10,
    };
  },
  methods: {
    ...mapActions(["getAllUsers", "deleteUserFromGroup", "addUsersToGroup", "getGroup"]),
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    closeModal() {
     this.showModal = false;
    },
    completeName({ firstname, lastname }) {
      return `${firstname}  ${lastname}`;
    },
    addUserToGroup(){
      this.isLoading = true;
      let formData = new FormData();
      formData.append("users", JSON.stringify(this.forms.user));
      formData.append("group", this.$route.params.id);
      this.addUsersToGroup(formData)
          .then(() => {
            this.forms.user.forEach(element => {
              this.group.users.unshift(element);
              for (let i = 0; i <  this.forms.users.length; i++) {
                if(this.forms.users[i].user_id == element.user_id){
                  this.forms.users.splice(i, 1);
                }
              }
            });

            this.isLoading = false;
            this.showModal = false;
            this.forms.user = [];
          })
          .catch(() => {
            this.$toasted.error(this.$t("pages.unauthorized.error_0"));
            this.isLoading = false;
          });
    },
    onDelete(user) {
      this.$toasted.clear();
      this.$swal({
        text: this.$t("pages.groups.users.swal") + ` ${user.firstname} ?`,
        confirmButtonColor: "#d33",
        confirmButtonText: this.$t("pages.groups.users.delete"),
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();
          formData.append("user", JSON.stringify([user.user_id]));
          formData.append("group", this.$route.params.id);
          this.deleteUserFromGroup(formData).then(()=>{
            this.$swal(
              this.$t("pages.groups.users.actions.confirm"),
              this.$t("pages.groups.users.actions.deleted"),
              "success"
            );
          });
          for (let i = 0; i <  this.group.users.length; i++) {
            let element =  this.group.users[i];

            if(element.user_id == user.user_id){
              this.group.users.splice(i,1);
              this.forms.users.unshift(user);
              break;
            }
          }
        }
      });
    },
    onDeleteUsers(){
      this.$toasted.clear();
      this.$swal({
        text: this.$t("pages.groups.users.swal_many"),
        confirmButtonColor: "#d33",
        confirmButtonText: this.$t("pages.groups.users.delete"),
      }).then((result) => {
        this.isLoading = true;
        if (result.value) {
          let formData = new FormData();
          formData.append("user", JSON.stringify(this.selectedUsers));
          formData.append("group", this.$route.params.id);
          this.deleteUserFromGroup(formData).then(()=>{
            this.$swal(
              this.$t("pages.groups.users.actions.confirm"),
              this.$t("pages.groups.users.actions.deleted"),
              "success"
            );
          });
          for (let i = 0; i < this.group.users.length; i++) {
            let element =  this.group.users[i];
            this.selectedUsers.forEach(uss => {
              if(element.user_id == uss){
                this.forms.users.unshift(element);
              }
            });
          }
          this.getGroup(this.$route.params.id).then((response) => { 
            this.group = response.data;
            this.isLoading = false;
          })
          this.selectedUsers = [];
        }
      });
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.user.users
    }),
    selectAllUsers: {
      get: function () {
          return this.group.users ? this.selectedUsers.length == this.group.users.length : false;
      },
      set: function (value) {
          var selectedUsers = [];

          if (value) {
              this.group.users.forEach(function (user) {
                  selectedUsers.push(user.user_id);
              });
          }

          this.selectedUsers = selectedUsers;
      }
    }
  },
  created() {
    this.isLoading = true;
    this.getGroup(this.$route.params.id).then((response) => {
      this.group = response.data;
      this.isLoading = false;
      this.getAllUsers().then(() => {
        var is_inside = false;
        this.users.forEach(a_user => {
          is_inside = false;
          this.group.users.forEach(g_user => {
            if(a_user.id == g_user.user_id) is_inside = true;
          });
          a_user.user_id = a_user.id;
          if(!is_inside) this.forms.users.push(a_user);
        });
      });
    });
  },
};
</script>